import { fetchWrapper } from "../../utils/fetchWrapper";
import { router } from "../../App"

import globalState from "../global-state";

import { gotoFaseProposta } from "./proposta";

export interface ILojaState {
    lojaUrl?: string
    logo?: string
    tokenMag?: string
    naoExistePaMag?: boolean
    grupoDePropostas?: any
    dadosRetornoIframe?: string
}

export const updateFaseMagFetch  = (idFaseMag: string) =>
    fetchWrapper(
        "/api/loja/savefasemag", 
        {
            method: "POST",
            body: JSON.stringify(idFaseMag)
        });

export const updateFaseMag = async (idFaseMag: string) => {
    globalState.isLoading.set(true)

    await updateFaseMagFetch(idFaseMag);

    globalState.isLoading.set(false)
};

export const contratarFake = async () => {
    var dadosLoja = `{
    "dadosOrigem": {
        "cnpjParceria": 1401771000153,
        "cnpjProponente": 31851334000100,
        "codigoBanco": [
            [
                133
            ]
        ],
        "corretor1": "6139650001502",
        "identificadorExterno": 31471,
        "sucursal": "H10",
        "susepCorretora": "202060630"
    },
    "propostas": [
        {
            "fatorComissionamento": "1",
            "linkPDF": "",
            "modeloProposta": "D8N",
            "numeroProposta": 114277744,
            "opcaoComissionamento": {
                "FatorDesconto": 1,
                "NumeroOpcao": 1,
                "PercentualAgenciamento": 1.25,
                "PercentualAgenciamentoProLabore": 0,
                "PercentualCorretagem": 0.4,
                "PercentualProLabore": 0
            },
            "premioTotal": 231.6975
        },
        {
            "fatorComissionamento": "1",
            "linkPDF": "",
            "modeloProposta": "D8N",
            "numeroProposta": 114277743,
            "opcaoComissionamento": {
                "FatorDesconto": 1,
                "NumeroOpcao": 1,
                "PercentualAgenciamento": 1.25,
                "PercentualAgenciamentoProLabore": 0,
                "PercentualCorretagem": 0.4,
                "PercentualProLabore": 0
            },
            "premioTotal": 45.119
        }
    ]
}`;
    saveDadosLoja({
        dadosRetornoIframe: dadosLoja
    } as ILojaState);

};

export const saveDadosLojaFetch  = (dadosLoja: ILojaState) =>
    fetchWrapper<ILojaState>(
        "/api/loja/save", 
        {
            method: "POST",
            body: JSON.stringify({
                ...dadosLoja
            })
        });

export const saveDadosLoja = async (dadosLoja: ILojaState) => {
    globalState.isLoading.set(true)

    await saveDadosLojaFetch(dadosLoja);

    await gotoFaseProposta()

    globalState.isLoading.set(false)
}

export const getLojaFetch = () =>
    fetchWrapper("/api/loja");

export const gotoFaseLoja = async () => {
    globalState.isLoading.set(true)
    
    const response = await getLojaFetch();

    globalState.faseLoja.set(response);
    
    await router.navigate("/loja", { replace: true });

    globalState.isLoading.set(false)
}
